// Module
var code = "<div id=\"rubric-widget-category-element\" data-cy=\"category-element\" class=\"rb-category rb-widget\"><div class=\"rb-title\" translate=\"rubric-widget-category_new-category\"></div></div>";
// Exports
module.exports = code;